import { Search, X } from "lucide-react";
import React, { useEffect, useRef } from "react";
import { useLocalStorage } from "../hooks/useLocalStorage";

export const SearchBar = ({ searchQuery, onSearchChange }) => {
	const inputRef = useRef(null);
	const [enableShortcut] = useLocalStorage("enableShortcut", true);

	useEffect(() => {
		const handleKeyDown = (e) => {
			if (enableShortcut && (e.metaKey || e.ctrlKey) && e.key === "f") {
				e.preventDefault();
				inputRef.current?.focus();
				inputRef.current?.select();
			}
		};

		window.addEventListener("keydown", handleKeyDown);
		return () => window.removeEventListener("keydown", handleKeyDown);
	}, [enableShortcut]);

	return (
		<div className="group relative flex h-8 w-full items-center">
			<Search className="pointer-events-none absolute left-2.5 h-3.5 w-3.5 text-[var(--input-placeholder)] transition-colors group-focus-within:text-[var(--color-text-primary)]" />
			<input
				ref={inputRef}
				type="text"
				placeholder={`Search by title, branch, author, project, or ticket${enableShortcut ? " (⌘F)" : ""}`}
				value={searchQuery}
				onChange={(e) => onSearchChange(e.target.value)}
				className="h-full w-full rounded-md border border-transparent bg-[var(--color-bg-secondary)] pl-8 pr-8 text-xs text-[var(--color-text-primary)] placeholder:text-[var(--input-placeholder)] transition-colors hover:border-[var(--color-border)] focus:border-transparent focus:bg-[var(--color-bg-primary)] focus:outline-none focus:ring-2 focus:ring-[var(--color-accent)] focus:ring-opacity-50"
			/>
			{searchQuery && (
				<button
					type="button"
					onClick={() => {
						onSearchChange("");
						inputRef.current?.focus();
					}}
					aria-label="Clear search"
					className="absolute right-1.5 flex h-5 w-5 items-center justify-center rounded-md text-[var(--input-placeholder)] hover:bg-[var(--color-bg-primary)] hover:text-[var(--color-text-primary)] active:scale-[0.92] transition-[background-color,color,transform]"
				>
					<X className="h-3 w-3" />
				</button>
			)}
		</div>
	);
};
